import ApplicationController from './application_controller';

// Extends from a base Stimulus ApplicationController
export default class extends ApplicationController {
  // Defines targets for easy reference inside the controller
  static targets = ['main', 'areaOfInterventionSelect'];
  // Defines values that can be passed into the controller
  static values = { skilledInterventionUrl: String };

  connect() {
    // Listen for a custom "fieldAdded" event and run addListeners when it fires
    document.addEventListener('fieldAdded', this.addListeners);
    // Also run addListeners immediately when the controller connects
    this.addListeners();
    // Start by toggling the state
    this.toggleSkilledButtons();
  }

  // Arrow function keeps `this` bound to the controller
  addListeners = () => {
    // Find all elements with class .skilled-intervention inside the main target
    const skilledContainer = this.mainTarget.querySelectorAll('.skilled-intervention');
    // Get the base URL for skilled interventions
    const skilledInterventionUrl = this.skilledInterventionUrlValue;
    // For each .skilled-intervention container
    skilledContainer.forEach((sc) => {
      // Find the awc-autocomplete element inside it
      const autocompleteSkilled = sc.querySelector('awc-autocomplete');
      // Set its "src" attribute dynamically, appending the selected areaOfIntervention ID
      autocompleteSkilled.setAttribute(
        'src',
        `${skilledInterventionUrl}&major_focus_area_tag_id=${this.areaOfInterventionSelectTarget.value}`
      );
    });
  };

  // Updates intervention fields when the area of intervention changes
  updateAreaOfIntervention(event) {
    // Get the new selected area ID from the event
    const areaOfInterventionId = event.target.value;
    // Get the base URL for skilled interventions
    const skilledInterventionUrl = this.skilledInterventionUrlValue;
    // Find all .skilled_intervention buttons in the main target's parent
    const skilledInterventionButton = this.mainTarget.parentElement.querySelectorAll('.skilled_intervention');
    // For each skilled intervention button
    skilledInterventionButton.forEach((sib) => {
      // Get the "data-fields" attribute (HTML string for new fields)
      const sibFields = sib.getAttribute('data-fields');
      // Create a template element and insert the HTML string
      const tpl = document.createElement('template');
      tpl.innerHTML = sibFields;
      // Find the awc-autocomplete inside the template
      const autocomplete = tpl.content.querySelector('awc-autocomplete');
      if (!autocomplete) return;
      // Extract the current "src" URL and parse it
      const autocompleteSrc = autocomplete.getAttribute('src');
      const autocompleteUrl = new URL(autocompleteSrc, window.location.origin);
      // Update the query param for major_focus_area_tag_id
      autocompleteUrl.searchParams.set('major_focus_area_tag_id', areaOfInterventionId);
      // Update the "src" with the modified URL
      autocomplete.setAttribute('src', `${autocompleteUrl.pathname}?${autocompleteUrl.searchParams.toString()}`);
      // Replace the data-fields attribute with the updated template HTML
      sib.setAttribute('data-fields', `${tpl.innerHTML}`);
    });
    // recheck if AOI is selected
    this.toggleSkilledButtons();
  }

  // enable/disable the SI button
  toggleSkilledButtons() {
    const hasSelection = !!this.areaOfInterventionSelectTarget.value;
    const skilledInterventionButtons = this.mainTarget.parentElement.querySelectorAll('.skilled_intervention');

    skilledInterventionButtons.forEach((btn) => {
      if (hasSelection) {
        btn.classList.remove('disabled');
        btn.removeAttribute('aria-disabled');
        btn.addEventListener('click', this.preventClick, { once: true }); // ensure reactivation works cleanly
      } else {
        btn.classList.add('disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.addEventListener('click', this.preventClick);
      }
    });
  }

  // helper to stop clicks when "disabled"
  preventClick = (event) => {
    if (event.currentTarget.classList.contains('disabled')) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  // disconnect event listener
  disconnect() {
    document.removeEventListener('fieldAdded', this.addListeners);
  }
}
